module.exports = __webpack_public_path__ + "img/lunch-break.dec366b7.png";